import { createSlice } from '@reduxjs/toolkit'
const initialState = {
  limit: 10,
  offset: 0,
  orderBy: 'latest',
  data: null,
}
const conversationsSlice = createSlice({
  name: 'conversations',
  initialState,
  reducers: {
    updateConversationState(state, action) {
      state[action.payload.key] = action.payload.value
    },
    removeReactionToSpecificPost(state, action) {
      if (state.data?.data?.postsResponseList?.length) {
        const post = state.data.data.postsResponseList.find(
          post => post.postId === action.payload
        )
        if (post) {
          post.noOfReactions = post.noOfReactions - 1
          post.reactionId = 0
          post.reactionType = ''
        }
      }
    },
    addReactionToSpecificPost(state, action) {
      if (state.data?.data?.postsResponseList?.length) {
        const { postId, reactionId, reactionType } = action.payload
        const post = state.data.data.postsResponseList.find(
          post => post.postId === postId
        )
        if (post) {
          post.noOfReactions =
            post.reactionType !== ''
              ? post.noOfReactions
              : post.noOfReactions + 1
          post.reactionId = reactionId
          post.reactionType = reactionType
        }
      }
    },
    updatePost(state, action) {
      if (state.data?.data?.postsResponseList?.length) {
        const {
          postId,
          comments,
          noOfComments,
          noOfReactions,
          reactionId,
          reactionType,
          reactions,
        } = action.payload
        const post = state.data.data.postsResponseList.find(
          post => post.postId === postId
        )
        if (post) {
          Object.assign(post, {
            comments,
            noOfComments,
            noOfReactions,
            reactionId,
            reactionType,
            reactions,
          })
        }
      }
    },
  },
})

export const conversationsReducer = conversationsSlice.reducer
export const {
  updateConversationState,
  removeReactionToSpecificPost,
  addReactionToSpecificPost,
  updatePost,
} = conversationsSlice.actions
